
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19 5C19 3.9 18.1 3 17 3H15C14.45 3 14 3.45 14 4C14 4.55 14.45 5 15 5H17V7.65L13.52 12H10V8C10 7.45 9.55 7 9 7H6C3.79 7 2 8.79 2 11V14H4C4 15.66 5.34 17 7 17C8.66 17 10 15.66 10 14H14.48L19 8.35V5ZM7 15C6.45 15 6 14.55 6 14H8C8 14.55 7.55 15 7 15Z' fill='#323232'/><path d='M9 4H6C5.45 4 5 4.45 5 5C5 5.55 5.45 6 6 6H9C9.55 6 10 5.55 10 5C10 4.45 9.55 4 9 4Z' fill='#323232'/><path d='M19 11C17.34 11 16 12.34 16 14C16 15.66 17.34 17 19 17C20.66 17 22 15.66 22 14C22 12.34 20.66 11 19 11ZM19 15C18.45 15 18 14.55 18 14C18 13.45 18.45 13 19 13C19.55 13 20 13.45 20 14C20 14.55 19.55 15 19 15Z' fill='#323232'/><path d='M7 20H11V18L17 21H13V23L7 20Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-electric-moped`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconElectricMoped

    ```js
    <b-new-b-icon-electric-moped />
    ```
</docs>


